import {Pipe, PipeTransform} from "@angular/core";
import * as moment from "jalali-moment";
import {TranslateService} from "../services/translate.service";

@Pipe({
    name: 'jalali'
})
export class JalaliPipe implements PipeTransform {
    constructor(private transl: TranslateService) {}
    transform(value: any, args?: any): any {
        const format = this.transl.dir === 'rtl' ? ('jYYYY-jMM-jDD') : ('YYYY-MM-DD');
        if (value) {
            const momentDate = moment(new Date(value)).locale(this.transl.lang);
            return momentDate.format(format);
        }
    }
}
